<div class="page-container" *transloco="let t">
  <app-header [title]="t('AUDIT-SETUP-PAGE.HEADER')" [progressIsVisible]="true" [progress]="progress" [withIcon]="true"></app-header>
  <div class="page-content">
    <ng-container *ngIf="currentIndex == 0">
      <app-type-view [(selectedType)]="state.selectedType" [showErrorMessage]="showErrorMessage"></app-type-view>
    </ng-container>
    <ng-container *ngIf="currentIndex == 1">
      <app-frequency-view [(selectedFrequency)]="state.prevalence" [showErrorMessage]="showErrorMessage"></app-frequency-view>
    </ng-container>
    <ng-container *ngIf="currentIndex == 2">
      <app-region-view [areaFormGroup]="areaFormGroup" [locationFormGroup]="locationFormGroup"></app-region-view>
    </ng-container>
  </div>
  <div class="container">
    <app-navigation-box class="navigation-button"
                        [rightText]="t(buttonText())"
                        [rightIsActive]="!isNextButtonDisabled()"
                        [leftIsVisible]="isNextIsAvailable()"
                        (rightIsPressed)="goForward()"
                        (leftIsPressed)="goBack()">
    </app-navigation-box>
  </div>
</div>

<app-popup [(isOpen)]="isOpen" [dynamicComponent]="ConfirmationComponent" [data]="popupData"/>

